var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBetaTagNoText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 41,
    viewBox: "0 0 72 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.832 32.5L71.332 0.5H0.332031V32.5H58.832Z",
    fill: "url(#paint0_linear_764_33125)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.33203 40.5L0.332031 32.5H6.33203V40.5Z",
    fill: "#6A2369"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_764_33125",
    x1: 37.4642,
    y1: 32.5,
    x2: 73.9134,
    y2: 29.2244,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A0439F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE59AD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBetaTagNoText);
export default __webpack_public_path__ + "static/media/betaTagNoText.8d66221f057570307199022888286477.svg";
export { ForwardRef as ReactComponent };